
const almeidaTech = {
    tabTitle: "Suporte AlmeidaTech",
    favicon: "/almeidatech.ico",
    title: "Centro de Suporte",
    loginTitle: "Centro de Suporte",
    logo: '/almeidatech-white.png',
    primary: 'primary',
    projectLabel: 'Projeto',
};


const dataCertify = {
    tabTitle: "Dashboard DataCertify",
    favicon: "/datacertify.ico",
    title: "Dashboard",
    loginTitle: null,
    logo: '/datacertify-white-large.png',
    primary: '#1A237E',
    projectLabel: 'Página',
};

function setFavicon(url: string) {
    var link = document.createElement('link'),
        oldLink = document.getElementById('dynamic-favicon');
    link.id = 'dynamic-favicon';
    link.rel = 'shortcut icon';
    link.href = url;
    if (oldLink) {
     document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
}

export const currentTheme = (() => {
    let theme: any = almeidaTech;
    if (window.location.host.includes('datacertify')) {
        theme = dataCertify;
    }
    document.title = theme.tabTitle;
    setFavicon(theme.favicon);
    return theme;
})();
